module.exports = __webpack_public_path__ + "static/media/4_5.d9eab7bd.png";